module.exports = __webpack_public_path__ + "../resources/images/illustration_trash-20239cb35a81a132b4ee234e1762c736.svg";